import {returnUrl} from "../utils/helpers";
import React, {useState} from "react";

export const useGuestContentFavorite = () => {
    const [show, setShow] = useState<boolean>(false);
    return {
        show,
        onToggle: () => setShow(!show),
        loginUrl: `/account/login?returnUrl=${returnUrl}`,
        registerUrl: `/account/register?returnUrl=${returnUrl}`,
        stopPropagation: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => e.stopPropagation()
    }
}